import React, { useState } from 'react';
import { Button } from '../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ShowMoreWrapper = function ShowMoreWrapper(_ref) {
  var children = _ref.children,
      numberToShow = _ref.numberToShow,
      rootClassName = _ref.rootClassName,
      buttonClassName = _ref.buttonClassName,
      _ref$showMoreLabel = _ref.showMoreLabel,
      showMoreLabel = _ref$showMoreLabel === void 0 ? 'Show more' : _ref$showMoreLabel,
      _ref$showLessLabel = _ref.showLessLabel,
      showLessLabel = _ref$showLessLabel === void 0 ? 'Show less' : _ref$showLessLabel,
      showButton = _ref.showButton;

  var _useState = useState(false),
      showMore = _useState[0],
      setShowMore = _useState[1];

  var handleToggleShowMore = function handleToggleShowMore() {
    setShowMore(!showMore);
  };

  var childArray = React.Children.toArray(children);
  var childrenToShow = showMore ? children : childArray.slice(0, numberToShow);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: rootClassName,
      children: childrenToShow
    }), childArray.length > numberToShow && /*#__PURE__*/_jsx("div", {
      className: buttonClassName,
      "data-cy": "ShowMoreWrapper",
      children: showButton ? /*#__PURE__*/_jsx(Button, {
        text: showMore ? showLessLabel : showMoreLabel,
        onClick: handleToggleShowMore,
        type: "secondary"
      }) : /*#__PURE__*/_jsx("span", {
        onClick: handleToggleShowMore,
        children: showMore ? showLessLabel : showMoreLabel
      })
    })]
  });
};